var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DotsThreeOutlineVertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 8.09375C7.60406 8.09375 8.09375 7.60406 8.09375 7C8.09375 6.39594 7.60406 5.90625 7 5.90625C6.39594 5.90625 5.90625 6.39594 5.90625 7C5.90625 7.60406 6.39594 8.09375 7 8.09375Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 3.71875C7.60406 3.71875 8.09375 3.22906 8.09375 2.625C8.09375 2.02094 7.60406 1.53125 7 1.53125C6.39594 1.53125 5.90625 2.02094 5.90625 2.625C5.90625 3.22906 6.39594 3.71875 7 3.71875Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 12.4688C7.60406 12.4688 8.09375 11.9791 8.09375 11.375C8.09375 10.7709 7.60406 10.2812 7 10.2812C6.39594 10.2812 5.90625 10.7709 5.90625 11.375C5.90625 11.9791 6.39594 12.4688 7 12.4688Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.82f7d4680434ff4bf732562ae78fa2ea.svg";
export { ForwardRef as ReactComponent };